'use client'
import * as Accordion from '@radix-ui/react-accordion'
import caviarImg from '@/assets/price-caviar.webp'
import { IconArrowR } from '@/icons'
import Reveal from '@/components/Reveal'

const GROUPS = [
  {
    title: 'Для оптовых покупателей',
    points: [
      'Минимальный объём заказа обсуждается индивидуально',
      'Отсрочка платежа для постоянных клиентов',
      'Доставка по России (спецтранспорт, соблюдение температурного режима)',
    ],
  },
  {
    title: 'Для ресторанов и HoReCa',
    points: [
      'Живая рыба «под заказ» — доставка за 24–48 часов',
      'Возможна поставка потрошёной и подготовленной рыбы',
      'Дегустационные образцы икры — бесплатно при первом контакте',
    ],
  },
  {
    title: 'Для инвесторов и партнёров',
    points: [
      'Готовы рассмотреть предложения о стратегическом партнёрстве',
      'Открыты к диалогу о вхождении в капитал или создании совместных проектов',
    ],
  },
]

const STEPS = [
  'Оставьте заявку — по телефону или email',
  'Согласуйте объём и спецификацию — мы подберём оптимальное решение под ваши задачи',
  'Получите первую поставку — точно в срок, с полным пакетом документов',
]

export default function Cooperation() {
  return (
    <section id="partners" className="sec-band sec-pad">
      <div className="container">
        <div className="price-section coop-section">
          <div className="price-bg" style={{ backgroundImage: `url(${caviarImg.src})` }} />

          {/* Single content block — image stays purely decorative on the right */}
          <div className="coop-inner">
            <Reveal><div className="coop-left">
              <span className="coop-eyebrow">Партнёрство</span>
              <h2 className="coop-heading">Условия<br />сотрудничества</h2>
              <p className="coop-sub">Индивидуальный подход для каждого партнёра</p>

              <Accordion.Root type="single" defaultValue="0" collapsible className="coop-accordion">
                {GROUPS.map((g, i) => (
                  <Accordion.Item value={String(i)} key={i} className="coop-acc-item">
                    <Accordion.Header>
                      <Accordion.Trigger className="coop-acc-trigger">
                        <span className="coop-acc-title">{g.title}</span>
                        <span className="coop-acc-icon" aria-hidden>
                          <svg className="coop-acc-chevron" width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M2.5 5L7 9.5L11.5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </span>
                      </Accordion.Trigger>
                    </Accordion.Header>
                    <Accordion.Content className="coop-acc-content">
                      <ul className="coop-acc-body">
                        {g.points.map((p, j) => <li key={j}>{p}</li>)}
                      </ul>
                    </Accordion.Content>
                  </Accordion.Item>
                ))}
              </Accordion.Root>
            </div></Reveal>

            <Reveal delay={160}><div className="coop-right">
              <p className="coop-steps-eyebrow">Как начать работу</p>
              <div className="coop-steps-list">
                {STEPS.map((s, i) => (
                  <div className="coop-step" key={i}>
                    <div className="coop-step-rail">
                      <div className="coop-step-num">{i + 1}</div>
                      {i < STEPS.length - 1 && <div className="coop-step-line" />}
                    </div>
                    <p className="coop-step-text">{s}</p>
                  </div>
                ))}
              </div>
              <button className="btn btn-primary btn-lg coop-cta" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
                Обсудить сотрудничество <IconArrowR width="16" height="16" />
              </button>
            </div></Reveal>
          </div>
        </div>
      </div>
    </section>
  )
}
